import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import styles from "./ShimmerText.module.css";

interface ShimmerTextProps {
  animate?: boolean;
  children: ReactNode;
  className?: string;
}

// Shimmer timing constants (in milliseconds)
const SHIMMER_DURATION_MS = 1000; // How long the shimmer effect lasts
const SHIMMER_INITIAL_DELAY_MS = 2000; // Delay before first shimmer
const SHIMMER_REPEAT_INTERVAL_MS = 10000; // Interval between shimmers

export const ShimmerText = ({
  children,
  className,
  animate = false,
}: ShimmerTextProps) => {
  const [isShimmering, setIsShimmering] = useState(false);

  useEffect(() => {
    if (!animate) return;
    let timeoutId: NodeJS.Timeout;
    let intervalId: NodeJS.Timeout;

    const startShimmer = () => {
      setIsShimmering(true);
      timeoutId = setTimeout(() => setIsShimmering(false), SHIMMER_DURATION_MS);
    };

    // Start the first shimmer after initial delay
    timeoutId = setTimeout(() => {
      startShimmer();
      // Then continue every repeat interval
      intervalId = setInterval(startShimmer, SHIMMER_REPEAT_INTERVAL_MS);
    }, SHIMMER_INITIAL_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [animate]);

  if (animate && isShimmering) {
    return (
      <span
        className={
          className ? `${styles.shimmerText} ${className}` : styles.shimmerText
        }
      >
        {children}
      </span>
    );
  }
  return (
    <span
      className={
        className ? `${styles.staticText} ${className}` : styles.staticText
      }
    >
      {children}
    </span>
  );
};
